import { useEffect, useState } from 'react';
import { setIsAdmin, setIsLoggedIn } from './store/reducers/loginSlice';
import { useDispatch, useSelector } from 'react-redux';
import { checkIsAdmin } from "./utils/apiHelper";
import { showToast } from "./store/reducers/notificationSlice";
import { useLocation } from 'react-router-dom';

const MessageReceiver = ({ children }) => {
    const [handshakeComplete, setHandshakeComplete] = useState(false);
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        // Extract token from URL
        const searchParams = new URLSearchParams(location.search);
        const token = searchParams.get('token');

        // Process token
        if (token) {
            console.log('Token extracted :', );
            sessionStorage.setItem('auth_token', token);
            sessionStorage.setItem('msg', ' extracted from URL');
            dispatch(setIsLoggedIn(true));

            checkIsAdmin(token)
                .then((isAdmin) => {
                    if (isAdmin === "true") {
                        console.log('User is admin');
                        dispatch(setIsAdmin(true));
                        sessionStorage.setItem('is_Admin', '1');
                    } else {
                        console.log('User is not admin');
                        dispatch(setIsAdmin(false));
                    }
                })
                .catch((err) => {
                    if (err.response && err.response.status === 403) {
                        dispatch(showToast({ message: "Login error", type: "error" }));
                    } else {
                        console.error(err);
                    }
                });

            // Set handshake complete
            setHandshakeComplete(true);
        }
    }, [dispatch, location.search]);

    return handshakeComplete ? children : <div>Error while authenticating</div>
};

export default MessageReceiver;
